import { render, staticRenderFns } from "./environment-summary-card.vue?vue&type=template&id=20efa9ec&scoped=true&"
import script from "./environment-summary-card.vue?vue&type=script&lang=js&"
export * from "./environment-summary-card.vue?vue&type=script&lang=js&"
import style0 from "./environment-summary-card.vue?vue&type=style&index=0&id=20efa9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20efa9ec",
  null
  
)

export default component.exports